// Choix de la langue : FR | EN. Sur les pages publiques, il vaut pour ce navigateur ; dans le menu utilisateur,
// il est aussi enregistré sur le compte (onChange).
import { choosePublicLang, LANGS, setLang, t, useLang, type Lang } from "../lib/i18n";
import { cx } from "./ui";

export function LangSwitch({ onChange, className }: { onChange?: (lang: Lang) => void; className?: string }) {
  const lang = useLang();
  return (
    <div role="radiogroup" aria-label={t("Langue")} className={cx("inline-flex rounded border border-line p-0.5", className)}>
      {LANGS.map((l) => (
        <button key={l.value} type="button" role="radio" aria-checked={lang === l.value} title={l.label}
          onClick={() => {
            if (onChange) {
              setLang(l.value);
              onChange(l.value);
            } else {
              choosePublicLang(l.value);       // page publique : gardé à la connexion
            }
          }}
          className={cx("rounded px-1.5 py-px font-mono text-[11px] uppercase cursor-pointer transition-colors",
            lang === l.value ? "bg-raised text-ink" : "text-faint hover:text-ink")}>
          {l.value}
        </button>
      ))}
    </div>
  );
}
